module.exports = __webpack_public_path__ + "static/media/icon-contact.0fd5b5bc.svg";